import { render, staticRenderFns } from "./SupportSteps.vue?vue&type=template&id=95c0c88c&scoped=true&"
import script from "./SupportSteps.vue?vue&type=script&lang=js&"
export * from "./SupportSteps.vue?vue&type=script&lang=js&"
import style1 from "./SupportSteps.vue?vue&type=style&index=1&id=95c0c88c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c0c88c",
  null
  
)

export default component.exports